/*
This file is located in the main branch
Last time the file was updated (UTC): [02.07.2024 18:52:59]
Permissions to update outside the main branch: [false]
*/

import { DropDown, PendingContainer, Tab } from '@finbeat/react-toolkit';
import { getLeadgenNamesDropDown } from 'axios/leadgenApi';
import useApi from 'hooks/useApi';
import { Key, useState } from 'react';
import { Trans } from 'react-i18next';
import { useQuery } from 'react-query';
import { Nav, NavItem, NavLink, TabContent } from 'reactstrap';
import LeadgenDailyStats from './LeadgenDailyStats';
import LeadgenHourlyStats from './LeadgenHourlyStats';
import LeadgenStats from './LeadgenStats';

export type LeadgenProps = {
    leagensList: DropDown[];
    leadgenListLoading: boolean;
};

const Leadgens = () => {
    const api = useApi();
    const className = 'leadgen';
    const [activeTab, setActiveTab] = useState('main');
    const [nameList, setNameList] = useState<DropDown[]>([]);

    const { isFetching } = useQuery('leadgenNameList', () => getLeadgenNamesDropDown(api), {
        onSuccess: (data) => {
            setNameList(data);
        },
        enabled: !nameList.length,
    });

    const toggleTab = (value?: Key) => {
        setActiveTab(value?.toString() ?? '');
    };

    return (
        <div className={className} data-testid="leadgens">
            <Nav className={`${className}__nav`} pills>
                <NavItem>
                    <NavLink
                        href="#"
                        onClick={() => setActiveTab('main')}
                        active={activeTab === 'main'}
                    >
                        <Trans i18nKey="BackOfficeMainPageName" />
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink
                        href="#"
                        onClick={() => setActiveTab('daily')}
                        active={activeTab === 'daily'}
                    >
                        <Trans i18nKey="BackOfficeDaily" />
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink
                        href="#"
                        onClick={() => setActiveTab('hourly')}
                        active={activeTab === 'hourly'}
                    >
                        <Trans i18nKey="BackOfficeHourly" />
                    </NavLink>
                </NavItem>
            </Nav>
            <TabContent activeTab={activeTab}>
                <Tab toggle={toggleTab} tabId="main">
                    <PendingContainer isPending={isFetching}>
                        <LeadgenStats leagensList={nameList} leadgenListLoading={isFetching} />
                    </PendingContainer>
                </Tab>
                <Tab toggle={toggleTab} tabId="daily">
                    <PendingContainer isPending={isFetching}>
                        <LeadgenDailyStats leagensList={nameList} leadgenListLoading={isFetching} />
                    </PendingContainer>
                </Tab>
                <Tab toggle={toggleTab} tabId="hourly">
                    <PendingContainer isPending={isFetching}>
                        <LeadgenHourlyStats
                            leagensList={nameList}
                            leadgenListLoading={isFetching}
                        />
                    </PendingContainer>
                </Tab>
            </TabContent>
        </div>
    );
};

export default Leadgens;
